import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import BottomAlert from '../components/BottomAlert';
import Card, { CardFooter, CardPadding } from '../components/Card';
import Chip from '../components/Chip';
import deviceStore from '../stores/deviceStore';
import walletStore from '../stores/walletStore';

export default function Home() {
  const navigate = useNavigate();
  const [isScanned, setIsScanned] = useState<boolean>(false);
  const [isBottomAlertOpen, setIsBottomAlertOpen] = useState<boolean>(false);
  const locationTimeId = useRef<any>(null);
  const init = deviceStore((s) => s.init);
  const keys = deviceStore((s) => s.keys);
  const device = deviceStore((s) => s.device);
  const linkHalo = deviceStore((s) => s.linkHalo);
  const loading = deviceStore((s) => s.loading);
  const getDeviceCompleted = deviceStore((s) => s.getDeviceCompleted);
  const connected = walletStore((s) => s.address).length > 0;
  const registered = deviceStore((s) => s.registered);

  const handleScanButtonClick = async () => {
    const response = await linkHalo();
    setIsScanned(response);
    if (!response) {
      setIsBottomAlertOpen((prevBottomAlertOpen) => !prevBottomAlertOpen);
      locationTimeId.current = setTimeout(() => window.location.reload(), 1500);
    }
  };

  useEffect(() => {
    init();
    return () => {
      if (locationTimeId.current) {
        clearTimeout(locationTimeId.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isScanned || !getDeviceCompleted || loading) return;
    if (device && registered) {
      return navigate('/success');
    } else if (keys) {
      return navigate('/fail');
    }
  }, [isScanned, loading, getDeviceCompleted, device, registered]);

  return (
    <div className='relative'>
      {loading ? (
        <Card className='card-loading text-white' loading={loading}>
          <h3 className='mt-25 text-2xl'>
            Scanning <br /> in progress
          </h3>
          <div className='text-sm pt-20'>
            <p>ARITIVIST CHIP provides an easy</p>
            <p>and secure method for verifying</p>
            <p>the provenance of artwork.</p>
          </div>
          <div className='text-sm pt-5'>
            <p>Simply tap with ARITIVIST CHIP.</p>
            <p>It verifies an artwork's authenticity</p>
            <p>across all times and places.</p>
          </div>
        </Card>
      ) : (
        <Card>
          <div className='pt-3 pl-4 pr-4'>
            <Chip detected={false} />
            <h1 className='home-title text-2xl font-expanded text-center'>
              Exploring the frontiers of art
            </h1>
            <p className='scan-description text-dark-gray text-sm mt-5 mb-9 text-center'>
              and crafting an experience
              <br />
              that transcends the constraints of
              <br />
              time and space.
            </p>
          </div>
          <CardFooter className='ml-4 mr-4'>
            <CardPadding>
              <Button className='scan-button' onClick={handleScanButtonClick}>
                <img src='/assets/scan.png' width='54' alt='스캔 아이콘'></img>
              </Button>
              <div className='text-center text-xs text-light-gray uppercase mt-3'>
                <span className='font-medium'>TAG </span>
                <span className='font-bold'>ARTIVIST CHIP</span>
              </div>
            </CardPadding>
          </CardFooter>
        </Card>
      )}
      {isBottomAlertOpen && (
        <BottomAlert
          message={
            <div>
              <p className='font-bold text-sm'>
                죄송합니다. 다시 시도해 주세요.
              </p>
            </div>
          }
        />
      )}
    </div>
  );
}
